'use client';

import { useRightDrawer } from '@/contexts/DrawerContext';
import { useTranslation } from '@/lib/i18n';
import { useEffect } from 'react';
import useSWR from 'swr';
import MarketEventListWithSkeleton, { MarketEventFeedItem } from '../../ui/MarketEvent';

interface MarketDrawerRenderProps {
  marketEventId?: string | number;
}
export default function MarketDrawerRender({ marketEventId }: MarketDrawerRenderProps) {
  const { t } = useTranslation();
  const { openDrawer } = useRightDrawer();
  const { data: relateEvents } = useSWR(
    marketEventId ? `api:/market/relate_events?market_event_id=${marketEventId}` : null,
    {
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    if (relateEvents?.data?.relate_events?.length) {
      openDrawer(<RecentEvent events={relateEvents.data.relate_events} />, t('Recent Event'), true);
    }
  }, [openDrawer, t, relateEvents]);
  return null;
}

function RecentEvent({ events }: { events?: MarketEventFeedItem[] }) {
  return <MarketEventListWithSkeleton loading={false} list={events || []} showMarket={false} />;
}
